import auth from '../../middleware/auth';
import store from '../../../store';

const props = (route) => {
	return {
		module: route.params.moduleName,
		device: store.getters['devices/current']
	};
};

export default {
	path: 'module/:moduleName',
	name: 'device-module',
	props: props,
	component: () => import('../../../views/device/Module'),
	meta: {
		collapse: true,
		static: false,
		middleware: [
			auth
		]
	}
};
